import Dimensions from "../models/Dimensions";
import { ImageModel } from "../models/ImageModel";
import Nullable from "../models/Nullable.types";

export function getDefaultTimezone() {
    return process.env.REACT_APP_TIMEZONE ?? 'UTC';
}

export function getBaseURL() {
    //if (window.location.hostname.indexOf('localhost') > -1) {
    if (process.env.REACT_APP_DEV === 'true') {
        return process.env.REACT_APP_BASE_URL;
    } else {
        return window.location.origin;
    }
}

export const paginateItems = (items: any[], currentPage: number, pageSize: number) => {
  const offset = pageSize * (currentPage - 1);
  return items.slice(offset, pageSize * currentPage);
}

export interface Json {
  [x: string]: string | number | boolean | Date | Json | JsonArray | undefined;
}
export interface JsonArray extends Array<string | number | boolean | Date | Json | JsonArray> { }
export async function fetchAPI<T>(action: string, params: Json = {}, preview: boolean = false) {
  var query = '';
  var keys = Object.keys(params);
  if (keys.length) {
      query = '?';
      keys.forEach((key, i) => {
          if (i > 0) {
              query += '&';
          }
          query += `${key}=${params[key] + ''}`
      })
  }
  const dateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(?:Z|(\+|-)([\d|:]*))?$/;
  const parseDates = (data: any) : any => {
      if (!data) {
          return data;
      }
      if (Array.isArray(data)) {
          return data.map(item => {
              return parseDates(item);
          })
      }
      else if (typeof (data) === 'object') {
          var keys = Object.keys(data);
          var result : Json = {};
          keys.forEach(key => {
              result[key] = parseDates(data[key]);
          });
          return result;
      }
      else if (typeof (data) === 'string') {
          var match = dateRegex.exec(data);
          if (match) {
              return new Date(data);
          }
      }
      return data;
  }

  const requestSettings = {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
          //'Api-Key': process.env.UMBRACO_API_KEY + '',
          //'Preview-Key': ''
      }
  };

  const res = await fetch(getBaseURL() + action + query, requestSettings);
  const json = await res.json();
  if (json.errors) {
      console.error(json.errors);
      throw new Error('Failed to fetch API');
  }
  const results = parseDates(json);
  return results as T;
}

export function getAbsoluteMediaUrl(url: string): string {
    if (!url) {
        return '';
    }
    if (url.indexOf('//') > -1) {
        return url;
    }
    return process.env.NEXT_PUBLIC_MEDIA_DOMAIN + url;
}

export function getMediaDimensions(model: ImageModel, cropAlias?: string, width?: number, height?: number): Nullable<Dimensions> {
    if (width !== undefined || height !== undefined) {
        if (width === 0 && height === 0) {
            return {
                width: model.width,
                height: model.height
            }
        }
        if (!height) {
            height = model.height * ((width || 0) / model.width);
        }
        else if (!width) {
            width = model.width * (height / model.height);
        }
        return {
            width: width || 0,
            height
        };
    }
    if (cropAlias) {
        var crop = model.crops && model.crops.crops ? model.crops.crops.find(x => x.alias.toLowerCase() === cropAlias.toLowerCase()) : null;
        if (!crop) {
            return {
                width: model.width,
                height: model.height
            };
        }
        return {
            width: crop.width,
            height: crop.height
        };
    }
    return null;
}

export function getCropUrl(model: ImageModel, cropAlias?: string, width?: number, height?: number): string {
    if (!model) {
        return '';
    }
    //var url = getAbsoluteMediaUrl(model.url);
    var url = model.url;
    if (width || height) {
        const dimensions = getMediaDimensions(model, cropAlias, width, height);
        if (dimensions) {
            return url + '?rnd=' + model.updateDate.getTime() + '&width=' + dimensions.width + '&height=' + dimensions.height;
        }
    }
    if (!model.crops || !cropAlias) {
        return url;
    }
    var crop = model.crops.crops.find(x => x.alias.toLowerCase() === cropAlias.toLowerCase());
    if (!crop) {
        return url;
    }
    var query = '';
    if (crop.coordinates) {
        if (crop.coordinates.left !== undefined) {
            query = '?rxy=' + crop.coordinates.left + ',' + crop.coordinates.top;
        } else {
            query = "?cc=" + crop.coordinates.x1 + ',' + crop.coordinates.y1 + ',' + crop.coordinates.x2 + ',' + crop.coordinates.y2;
        }
    }
    else if (model.crops.focalPoint && model.crops.focalPoint.left !== undefined) {
        query = '?rxy=' + model.crops.focalPoint.left + ',' + model.crops.focalPoint.top;
    }
    query += (query ? '&' : '?') + '&rnd=' + model.updateDate.getTime() + '&width=' + crop.width + '&height=' + crop.height;
    return (process.env.REACT_APP_DEV === 'true' ? process.env.REACT_APP_BASE_URL : '') +  url + query;
}

export function checkDateIfSame(date1: Date, date2: Date) {
    const date = new Date(date1);
    const dateToCompare = new Date(date2);
    let result = false;
    //console.log('date.getYear', date.getFullYear());
    if (date.getFullYear() < 2000) {
        result = true;
    }
    else {
        result = date.getFullYear() === dateToCompare.getFullYear() && date.getMonth() === dateToCompare.getMonth() && date.getDay() === dateToCompare.getDay();
    }
    return result;
}

export function filterOnlyUnique(value: any, index: number, array: any) {
    return array.indexOf(value) === index;
}

export function getSearchMessage(searchTerm: string, totalRecords: number, noResultMessage: string, resultMessage: string) {
  let message = '';
  if (searchTerm.length > 0) {
    message = noResultMessage;
    if (totalRecords > 0) {
      message = resultMessage.replace('[count]', totalRecords.toString());
    }
    message = message.replace('[searchTerm]', searchTerm);
  }

  return message;
}

export function getServerTimezoneDate(date: Date) {
    return new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1000)
}